'use strict';

angular.module('atex.art').factory('ArtSyncModal',
['$rootScope', '$q', '$modal',

  function($rootScope, $q, $modal) {
    return {
      create: function(params) {
        var defaultParams = { actionHeader: 'Synchronizing application...' };

        var syncArgs = _.extend({}, defaultParams, params);
        var syncScope = $rootScope.$new(true);

        syncScope.actionHeader = syncArgs.actionHeader;
        syncScope.progress = '';

        var modal = $modal({
          show: true,
          scope: syncScope,

          template: 'templates/sync-modal.html',
          modalClass: 'sync-modal',

          backdrop: 'static',
          keyboard: false
        });

        syncScope.destroyModal = function() {
          var onDestroyedDeferred = $q.defer();

          /**
           * The Angular Strap modal creates a new child scope for itself.
           * Thus, in order for the modal content to be able to be unaware of
           * the parent scope completely, we have to handle the destruction
           * of the modal like this.
           *
           * The reason we wait for the 'hidden' event is because that's the
           * only point in time where we know the modal hide sequence is
           * completed.
           */

          modal.then(function(modalEl) {
            modalEl.on('hidden.bs.modal', function() {
              syncScope.$destroy();
              onDestroyedDeferred.resolve();
            });

            modalEl.modal('hide');
          });

          return onDestroyedDeferred.promise;
        };

        return {
          setProgress: function(percent) {
            syncScope.progress = percent + '%';
          },

          setActionMessage: function(message) {
            syncScope.actionMessage = message;
          },

          destroy: function() {
            return syncScope.destroyModal();
          }
        };
      }
    };
  }
]);
